var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "raf-friend-holder" }, [
    _vm.promoActive
      ? _c(
          "div",
          _vm._l(_vm.promos, function(promo) {
            return _c(
              "div",
              { key: promo.PromoCode, staticClass: "promotion raf-friend" },
              [
                _c("h3", { staticClass: "subtitle" }, [
                  _vm._v(_vm._s(promo.Description))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "raf_friend_content" }, [
                  _c("p", [_vm._v(" " + _vm._s(promo.Note) + " ")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.$t("Account.ReferAFriend.ReferalCodeBellow")
                        ) +
                        " "
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "code-container" }, [
                    _c("span", { staticClass: "code" }, [
                      _vm._v(_vm._s(promo.PromoCode))
                    ]),
                    _vm._v(" "),
                    _c(
                      "label",
                      { staticClass: "copy", on: { click: _vm.copyCode } },
                      [
                        _c("icon", { attrs: { name: "icon-copy-black" } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "copySpanText" }, [
                          _vm._v(
                            " " + _vm._s(_vm.$t("Account.ReferAFriend.CopyBtn"))
                          )
                        ])
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("input", {
                      staticClass: "copyBtn",
                      attrs: { type: "button" }
                    }),
                    _vm._v(" "),
                    _c("br")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "terms-rate" }, [
                    _c(
                      "p",
                      {
                        staticClass: "terms-link",
                        on: {
                          click: function($event) {
                            return _vm.toggleRafPromoTerms()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("Account.ReferAFriend.TermsLink")))]
                    ),
                    _vm._v(" "),
                    promo.MaxRefferesCount > 0
                      ? _c("span", { staticClass: "response-rate" }, [
                          _vm._v(
                            _vm._s(
                              _vm.$t("Account.ReferAFriend.MaxReferrals")
                            ) +
                              ": " +
                              _vm._s(promo.MaxRefferesCount) +
                              "    " +
                              _vm._s(_vm.$t("Account.ReferAFriend.Referrals")) +
                              ": " +
                              _vm._s(promo.RefferesCount)
                          )
                        ])
                      : _c("span", { staticClass: "response-rate" }, [
                          _vm._v(
                            _vm._s(_vm.$t("Account.ReferAFriend.Referrals")) +
                              ": " +
                              _vm._s(promo.RefferesCount)
                          )
                        ]),
                    _vm._v(" "),
                    _vm.rafPromoTermsPopUp
                      ? _c("div", { staticClass: "tandc-popup-container" }, [
                          _c("div", { staticClass: "tandc-popup-child" }, [
                            _c("div", { staticClass: "tandc-popup-content" }, [
                              _c("div", {
                                staticClass: "tc-text",
                                domProps: {
                                  innerHTML: _vm._s(_vm.rafPromoTermsHtml)
                                }
                              })
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-actions" },
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "btn primary-btn",
                                    on: {
                                      click: function($event) {
                                        return _vm.toggleRafPromoTerms()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("Account.JoinUs.Popup.Close")
                                      )
                                    )
                                  ]
                                )
                              ],
                              1
                            )
                          ])
                        ])
                      : _vm._e()
                  ])
                ])
              ]
            )
          }),
          0
        )
      : _c("div", [
          _c("p", [_vm._v(_vm._s(_vm.$t("Account.ReferAFriend.NoPromo")))])
        ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29778142", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29778142","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/account/ReferAFriendInfo.vue
// module id = null
// module chunks = 